import React from 'react';
import ReactDOM from 'react-dom';
import Provider from './utils/Provider';

import store, { history } from './store';
import App from './App';
import * as serviceWorker from './serviceWorker';

//React cache buster
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';

const isProduction = process.env.NODE_ENV === 'production';

ReactDOM.render(
  <CacheBuster
    currentVersion={version}
    isEnabled={isProduction}
    isVerboseMode={false}
    loadVersionFirst={true} // Important for v0.1.6
    onCacheClear={() => {
      console.log('Cache cleared by react-cache-buster');
    }}
  >
    <Provider store={store} history={history}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  </CacheBuster>,
  document.getElementById('root')
);

// Modified service worker registration that works with react-cache-buster
if (isProduction) {
  serviceWorker.register({
    onUpdate: (registration) => {
      // Let react-cache-buster handle the update instead of SW
      console.log('Service worker update detected - letting react-cache-buster handle it');

      // Skip waiting and let the cache buster take over
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Don't reload here - let react-cache-buster decide
    },
    onSuccess: (registration) => {
      console.log('SW registered successfully');
    },
  });
} else {
  // Don't use service worker in development
  serviceWorker.unregister();
}
